'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';

const __endpoints = require('endpoints.service');

export default class StoreForecastTags extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
		];
		this.settings = {
			name: 'StoreForecastTags',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			translationPath: 'ADMINISTRATION.STORE_FORECAST_TAGS',
			canManipulate: () => validAccess(undefined, ['Global BI Configuration']),

			endpoint: __endpoints.collection.administration.store_forecast_tags,
		};
		this.init();
		return this;
	}
}
